const show = async ({ commit }, payload) => {
    console.log("snackbar.show", payload);
    let data = Object.assign({ visible: true }, payload);
    if (typeof (data.text) !== "string") {
        if (typeof (data.text.Message) === "string") data.text = data.text.Message;
        else data.text = JSON.stringify(data.text.Message);
    };
    commit({ type: "loadData", data });
};

const hide = async ({ commit }, payload) => {
    console.log("snackbar.hide", payload);
    let data = Object.assign({ visible: false }, payload);
    commit({ type: "loadData", data });
};

export default {
    show,
    hide,
};



// WEBPACK FOOTER //
// src/store/views/snackbar/actions.js